import { put, call, select } from 'redux-saga/effects';
import { Types } from './actions';
import AcademicDatesRepository from '../../../repositories/AcademicDatesRepository';
import AcademicDatesDataRepository from '../../../../data/repositories/AcademicDatesDataRepository';
import DateHelpers from '../../../../core/helpers/DateHelper';
import constants from '../../../../core/constants';

export default function* execute(): any {
  try {
    const today = DateHelpers.getPeruDate();

    const initialdata = {
      academicDatesForToday: [],
      otherAcademicDates: []
    };
    yield put({ type: Types.GET_ACADEMIC_DATES_REQUEST, data: initialdata });

    const { data: dataPeriods } = yield select(
      (state: any) => state.getPeriods
    );
    const currentPeriod = dataPeriods?.find((p: any) => !!p.isCurrent);
    // consultar horario
    const academicDatesRepository: AcademicDatesRepository =
      new AcademicDatesDataRepository();
    const academicDatesResponse = yield call(
      academicDatesRepository.getAcademicDates,
      currentPeriod?.period ?? ''
    );
    if (!academicDatesResponse) {
      yield put({
        type: Types.GET_ACADEMIC_DATES_FAILURE,
        error: 'Ocurrió un error.'
      });
      return;
    }
    const academicDates: any[] = academicDatesResponse;
    const nacademicDates = academicDates.map((date: any) => ({
      ...date,
      startTime: new Date(date.startDate),
      endTime: new Date(date.endDate),
      startDate: date.startDate + constants.MIL_PERU * 2,
      endDate: date.endDate + constants.MIL_PERU * 2
    }));
    const todayTimeStamp = DateHelpers.converDateToEpoch(today) * 1000;
    const academicDatesForToday = nacademicDates.filter(
      (m) =>
        DateHelpers.isSameDay(m.startDate, todayTimeStamp) ||
        DateHelpers.isSameDay(m.endDate, todayTimeStamp)
    );
    const academicDatesForNextDays = nacademicDates.filter(
      (m) =>
        new Date(m.startDate).getTime() !== today.getTime() &&
        new Date(m.endDate).getTime() !== today.getTime()
    );

    const data = {
      all: nacademicDates,
      forToday: academicDatesForToday,
      forComingNext: academicDatesForNextDays
    };
    yield put({ type: Types.GET_ACADEMIC_DATES_SUCCESS, data });
  } catch (error) {
    yield put({
      type: Types.GET_ACADEMIC_DATES_FAILURE,
      error: 'Ocurrió un error.'
    });
    throw error;
  }
}
